import CoilChip from '../room-overview/CoilChip';
import { FieldStrengthTile } from '../room-overview/FieldStrengthChip';
import { parseCoils } from '../room-overview/utils';
import { ScannerMember } from '../../services/api/folderService';

export const buildScannerSecondaryLine = (scanner: ScannerMember): string => {
    const parts: string[] = [];
    if (scanner.Model) parts.push(scanner.Model);
    if (scanner.Manufacturer) parts.push(scanner.Manufacturer);
    if (scanner.FieldStrength !== undefined)
        parts.push(`${scanner.FieldStrength}T`);
    if (scanner.TRCoils) parts.push(scanner.TRCoils);
    return parts.join(' · ');
};

interface ScannerMemberItemProps {
    scanner: ScannerMember;
    onSelect: (scannerId: string) => void;
}

export const ScannerMemberItem = ({
    scanner,
    onSelect,
}: ScannerMemberItemProps) => {
    const coils = parseCoils(scanner.TRCoils);

    return (
        <button
            type="button"
            onClick={() => onSelect(scanner._id)}
            className="flex w-full items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-muted"
        >
            {scanner.FieldStrength !== undefined && (
                <FieldStrengthTile fieldStrength={scanner.FieldStrength} />
            )}
            <div className="min-w-0 flex-1 sm:flex sm:items-center sm:gap-4">
                <div className="min-w-0 flex-1">
                    <div className="truncate text-sm font-medium text-foreground">
                        {scanner.Name ?? ''}
                    </div>
                    {(scanner.Manufacturer || scanner.Model) && (
                        <div className="mt-0.5 truncate text-xs font-medium text-subtle-foreground">
                            {[scanner.Manufacturer, scanner.Model]
                                .filter(Boolean)
                                .join(' ')}
                        </div>
                    )}
                </div>
                {coils.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-1 sm:mt-0 sm:max-w-[50%] sm:justify-end">
                        {coils.map((coil, index) => (
                            <CoilChip key={`${coil}-${index}`} coil={coil} />
                        ))}
                    </div>
                )}
            </div>
        </button>
    );
};
